import { Button } from "@mui/material";
import React from "react";
import { indigo } from "@mui/material/colors";

const CustomButton = ({ label, onClick, disabled }) => (
  <Button
    sx={{
      bgcolor: indigo[900],
      height: 50,
      borderRadius: 2,
      width: "100%",
      textTransform: "none",
      fontSize: 16,
      fontWeight: 600,
      "&.Mui-disabled": {
        bgcolor: "rgba(26, 35, 126, 0.4)",
        color: "#fff",
      },
    }}
    variant="contained"
    size="medium"
    onClick={onClick}
    disabled={disabled}
  >
    {label}
  </Button>
);

export default CustomButton;
